import React, { useEffect }                from 'react';
import { CURRENCY }                        from '../../../Config';
import { analytics }                       from '../../../helpers/firebaseHelper';
import getPhotos , { LARGE }               from '../../../helpers/getPhotos';
import withLayout                          from '../../../hoc/withLayout';
import { Modal }                           from '@redq/reuse-modal';
import PageMeta                            from '../../../components/PageMeta';
import { useQuery }                        from '@apollo/client';
import { GET_POST }                        from '@core/ui/graphql/Post.query';
import { useRouter }                       from 'next/router';
import { getSidFromSlug, getUrl, slugify } from '../../../helpers/urlHandler';
import { isMobile, isFirefox }             from 'react-device-detect';
import SinglePost                          from '../../../containers/SinglePost';
import { SINGLE_POST_PAGE }                from '@core/ui/navigation/constant';
import simplePage                          from "../../../serverProps/simplePage";

const Ads = ({ ...props }) => {

    const router = useRouter();

    const { query : { slug : routerSlug } } = router ;

    const slug = getSidFromSlug( routerSlug ) ;
    const QUERY_VARIABLES = {
        LIMIT: 4,
        slug,
    };
    const { data, loading, error } = useQuery(GET_POST, {
        variables: QUERY_VARIABLES,
    });

    const {
        post : {
            category = '' ,
            deleted = false,
            description : content = '' ,
            media ,
            photos ,
            price = '',
            sid = '' ,
            title = ''
        } = {}
    } = data || {} ;

    const mediaGallery = getPhotos( media , photos , LARGE ) ;

    let canonical = false;

    useEffect(() => {
        if( !loading && !sid )
        {
            router.push('/');
        }

        const isShare = getUrl().hasOwnProperty('s');
        if (isShare && isMobile && !isFirefox) {
            // redirect to application
            // if a mobile does not have the app installed this code will generate firefox protocol error page
            window.location.href = process.env.DEEP_LINK + '/annonce?id=' + slug;
        }

        if( typeof window !== 'undefined' && analytics )
        {
            analytics.logEvent( 'view_item' , {
                currency : CURRENCY,
                items    :
                [{
                    id       : sid ,
                    name     : title ,
                    category ,
                    price
                }],
                value    : price
            } ) ;
        }
    }, [data]);

    if (!loading) {
        canonical = `${process.env.SITE_URL}/${SINGLE_POST_PAGE}/${slugify(
            category
        )}/${slugify(title)}-${sid}`;
    }

    return (
        <>
            <PageMeta
                title       = { title }
                description = { content }
                media       = { mediaGallery }
                canonical   = { canonical }
                type        = "article"
                noindex     = { deleted }
            />
            <SinglePost
                {...props}
                data            = { data }
                loading         = { loading }
                error           = { error }
                QUERY_VARIABLES = { QUERY_VARIABLES }
            />
            <Modal />
        </>
    );
};

export default withLayout( Ads ) ;

export const getServerSideProps = simplePage;
